import React from "react";

export default function Button({ label = "Button", onSubmit }) {
  return (
    <button
      className="p-3 mt-6 w-full h-14 rounded-full text-base bg-[#4B8AEB] text-white"
      onClick={onSubmit}
    >
      {label}
    </button>
  );
}
